export function getImageAltTextAndUrl(event) {
    const { currentTarget } = event;
    const element = currentTarget.querySelector('picture > img');
    if (element) {
        const { currentSrc, alt } = element;
        return {
            altText: alt,
            imageUrl: currentSrc,
        };
    }
    return undefined;
}
//# sourceMappingURL=index.js.map